"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_toastify_1 = require("react-toastify");
var menu_1 = require("./menu");
var auth_1 = require("~contexts/auth");
var scripts = document.getElementsByTagName('script');
var javascriptHash;
for (var i = 0; i < scripts.length; i++) {
    var scriptLink = (_b = (_a = scripts.item(i)) === null || _a === void 0 ? void 0 : _a.attributes.getNamedItem('src')) === null || _b === void 0 ? void 0 : _b.nodeValue;
    if (scriptLink && scriptLink.startsWith('/js/app.js')) {
        javascriptHash = scriptLink.split('?')[1];
        break;
    }
}
function App() {
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(null), user = _b[0], setUser = _b[1];
    var _c = (0, react_1.useState)(''), theme = _c[0], setTheme = _c[1];
    var _d = (0, react_1.useState)(''), background = _d[0], setBackground = _d[1];
    (0, react_1.useEffect)(function () {
        var _this = this;
        axios_1.default.get('/api/user')
            .then(function (response) { return setUser(response.data); })
            .catch(function () { return setUser(null); })
            .finally(function () { return setLoading(false); });
        var interval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get("/mix-manifest.json?".concat(Date.now()))];
                    case 1:
                        response = _a.sent();
                        if (response.data['/js/app.js'].split('?')[1] !== javascriptHash) {
                            (0, react_toastify_1.toast)('There\'s an update available for NekoBot. Please refresh the page to get the latest version.', {
                                type: 'info',
                                autoClose: false,
                                position: 'bottom-center',
                            });
                            clearInterval(interval);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 6e5);
        return function () { return clearInterval(interval); };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_1.default.StrictMode, null,
            react_1.default.createElement(auth_1.AuthProvider, { value: user },
                react_1.default.createElement(menu_1.Sidebar, null),
                react_1.default.createElement("div", { className: "sidebar-divider" }),
                react_1.default.createElement("div", { id: "content", className: "container-fluid py-2 overflow-auto position-relative" },
                    background.length > 0 && react_1.default.createElement("div", { className: "background-manager", style: { backgroundImage: background } }),
                    !loading && (react_1.default.createElement(react_router_1.Outlet, null))))),
        react_1.default.createElement(react_toastify_1.ToastContainer, { theme: "dark" })));
}
exports.default = App;
